// extracted by css-extract-rspack-plugin
export default {"projectWrapper":"ProjectV2ItemStatusChangedEvent-module__projectWrapper__FjUMB"};